import { useAtom } from 'jotai/react';
import { useEffect } from 'react';

import { useCodWeb as useCodWebApi } from '@/api/use-codweb';
import { useProvider } from '@/hooks/use-provider';
import { codWebAtom } from '@/lib/store';
import { PROVIDERS } from '@/providers';

export const useCodWeb = () => {
  const [provider] = useProvider();
  const codWebQuery = useCodWebApi();
  const [codWeb, setCodWeb] = useAtom(codWebAtom);

  useEffect(() => {
    if (provider.id !== PROVIDERS.SALESFORCE && codWebQuery.data) {
      setCodWeb(codWebQuery.data);
    }
  }, [provider.id, codWebQuery.data, setCodWeb]);

  return codWeb || '';
};
